import React, { useState } from "react";
import Select from "react-select";
import ButtonCommonComponent from "../common/ButtonCommonComponent";
import DisplaySelectedOptionsList from "../common/DisplaySelectedOptionsList";

const optionsSkill = [
  { value: "Skill Name 1", label: "Skill Name 1" },
  { value: "Skill Name 2", label: "Skill Name 2" },
  { value: "Skill Name 3", label: "Skill Name 3" },
  { value: "Skill Name 4", label: "Skill Name 4" },
  { value: "Skill Name 5", label: "Skill Name 5" },
  { value: "Skill Name 6", label: "Skill Name 6" },
];
const optionsLocation = [{ value: "Remote", label: "Remote" }];
const optionsPayRate = [{ value: "13", label: "$13" }];
const optionsUrgency = [{ value: "Immediately", label: "Immediately" }];

export default function AgencyDashboardNewRequirementsFirstTime({
  handleOnClickDoItLater,
}) {
  const [values, setValues] = useState({
    activeIndex: 0,
    selectedValSkill: "",
    displayListSelected: [],
    selectedValLocation: "",
    selectedValPayRate: "",
    selectedValUrgency: "",
  });

  const handleChangeDropdownSkill = (selectedOption) => {
    let newList = values.displayListSelected;
    if (newList.indexOf(selectedOption) === -1) {
      newList.push(selectedOption);
      setValues({
        ...values,
        selectedValSkill: selectedOption,
        displayListSelected: newList,
      });
    } else {
      setValues({
        ...values,
        selectedValSkill: selectedOption,
      });
    }
  };

  const handleRemoveMember = (index) => (e) => {
    let newList = values.displayListSelected;
    newList.splice(index, 1);
    setValues({
      ...values,
      displayListSelected: newList,
      selectedValSkill: "",
    });
  };

  const handleChangeDropdownLocation = (selectedOption) => {
    setValues({ ...values, selectedValLocation: selectedOption });
  };

  const handleChangeDropdownPayRate = (selectedOption) => {
    setValues({ ...values, selectedValPayRate: selectedOption });
  };

  const handleChangeDropdownUrgency = (selectedOption) => {
    setValues({ ...values, selectedValUrgency: selectedOption });
  };

  const handleOnClickNext = (val) => (e) => {
    setValues({ ...values, activeIndex: val });
  };

  const renderTitle = (text) => {
    return <h2 className="font-48-NunitoSans-600 mb-10">{text}</h2>;
  };

  return (
    <div className="row mx-0 align-items-center justify-content-center mt-agency-dashboard-first-time-block">
      <div className="mt-agency-dashboard-first-time-block__content">
        {values.activeIndex === 0 && (
          <>
            {renderTitle("Welcome !")}
            <p className="font-24-NunitoSans-600 color-white-66 mb-10">
              You currently have no preferences set
            </p>
            <p className="font-24-NunitoSans-600 mb-25">
              Lets start by Setting a few
            </p>
            <ButtonCommonComponent
              extraClassName="mb-25"
              text="Start"
              onClick={handleOnClickNext(1)}
            />
            <br />
            <button
              className="do-it-later-btn"
              onClick={handleOnClickDoItLater}
            >
              Do it later
            </button>
          </>
        )}
        {values.activeIndex === 1 && (
          <>
            {renderTitle("Let’s start")}
            <p className="font-24-NunitoSans-600 color-white-66 mb-46">
              What are your key skills?
            </p>
            <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
              Select Skills
            </p>
            <div className="react-select-agency-dashboard-first-time">
              <Select
                className="react-select-container"
                classNamePrefix="react-select-elements"
                isSearchable={false}
                options={optionsSkill}
                value={values.selectedValSkill}
                onChange={handleChangeDropdownSkill}
                placeholder="Select"
              />
              {/* display error */}
            </div>
            <DisplaySelectedOptionsList
              displayListSelected={values.displayListSelected}
              handleRemoveMember={handleRemoveMember}
            />
            <ButtonCommonComponent
              extraClassName="mt-50 login-btn--px-45"
              text="Save &amp; Next"
              onClick={handleOnClickNext(2)}
            />
          </>
        )}
        {values.activeIndex === 2 && (
          <>
            {renderTitle("Let’s start")}
            <p className="font-24-NunitoSans-600 color-white-66 mb-46">
              Which Location would you prefer?
            </p>
            <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
              Select
            </p>
            <div className="react-select-agency-dashboard-first-time">
              <Select
                className="react-select-container"
                classNamePrefix="react-select-elements"
                isSearchable={false}
                options={optionsLocation}
                value={values.selectedValLocation}
                onChange={handleChangeDropdownLocation}
                placeholder="Select"
              />
              {/* display error */}
            </div>
            <ButtonCommonComponent
              extraClassName="mt-50 login-btn--px-45"
              text="Save &amp; Next"
              onClick={handleOnClickNext(3)}
            />
          </>
        )}
        {values.activeIndex === 3 && (
          <>
            {renderTitle("Let’s start")}
            <p className="font-24-NunitoSans-600 color-white-66 mb-46">
              Which payrate are you expecting
            </p>
            <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
              Select Rate{" "}
              <span className="color-white-66">
                (which will be Rate/hr/resource)
              </span>
            </p>
            <div className="react-select-agency-dashboard-first-time">
              <Select
                className="react-select-container"
                classNamePrefix="react-select-elements"
                isSearchable={false}
                options={optionsPayRate}
                value={values.selectedValPayRate}
                onChange={handleChangeDropdownPayRate}
                placeholder="Select"
              />
              {/* display error */}
            </div>
            <ButtonCommonComponent
              extraClassName="mt-50 login-btn--px-45"
              text="Save &amp; Next"
              onClick={handleOnClickNext(4)}
            />
          </>
        )}
        {values.activeIndex === 4 && (
          <>
            {renderTitle("Let’s start")}
            <p className="font-24-NunitoSans-600 color-white-66 mb-46">
              How soon can you start?
            </p>
            <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
              Select Urgency
            </p>
            <div className="react-select-agency-dashboard-first-time">
              <Select
                className="react-select-container"
                classNamePrefix="react-select-elements"
                isSearchable={false}
                options={optionsUrgency}
                value={values.selectedValUrgency}
                onChange={handleChangeDropdownUrgency}
                placeholder="Select"
              />
              {/* display error */}
            </div>
            <ButtonCommonComponent
              extraClassName="mt-50 login-btn--px-45"
              text="Save &amp; Next"
              onClick={handleOnClickNext(5)}
            />
          </>
        )}
        {values.activeIndex === 5 && (
          <>
            {renderTitle("Alright!")}
            <p className="font-24-NunitoSans-600 color-white-66 mb-23">
              You are all set to see the client listings
            </p>
            <p className="font-16-NunitoSans-600 mb-55">
              You can change these preferences and enhance your search anytime!
            </p>

            <ButtonCommonComponent
              extraClassName="login-btn--px-45"
              text="See Listings"
              onClick={handleOnClickDoItLater}
            />
          </>
        )}
      </div>
    </div>
  );
}
